// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1UOc1","filesListContainer":"PosDisputesFiles_filesListContainer__1Ta1x","filesButton":"PosDisputesFiles_filesButton__2KV7I"};